import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useReservationsStore = defineStore('reservations', () => {
  /* State */
  const items = ref([]);
  const selected = ref([]);

  /* Getters */
  const isSelfCancelable = computed(() =>
    items.value.reduce((prev, cur) => prev && cur.isSelfCancelable, true),
  );
  const isNotRefundable = computed(() =>
    items.value.reduce(
      (prev, cur) =>
        prev &&
        !cur.isRefundable &&
        cur.isSelfCancelable &&
        cur.reservationStatus.toLowerCase() === 'confirmed',
      true,
    ),
  );

  return {
    items,
    selected,
    isSelfCancelable,
    isNotRefundable,
  };
});
